export default "__VITE_ASSET__BwfI4Oxr__"